import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import blogPosts from "@/data/blogPosts";
import { WHATSAPP_URL as WHATSAPP_LINK } from "@/constants/contact";

const BlogPage = () => {
  return (
    <div className="bg-warm-white min-h-screen">
      <SEO
        title="Blog — Insights on Plastic Surgery"
        description="Read expert insights on plastic surgery, recovery, and patient care from Dr. Vicky Jain — board-certified plastic and reconstructive surgeon."
        canonical="/blog"
      />

      {/* Hero */}
      <section className="bg-warm-white pt-32 pb-16 px-4 md:px-8">
        <div className="container mx-auto max-w-7xl">
          <p className="text-sm font-medium tracking-widest text-gold uppercase mb-4">Blog</p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-premium-purple mb-6 max-w-3xl">
            Insights from Dr. Vicky Jain
          </h1>
          <p className="text-lg text-deep-navy/70 max-w-2xl leading-relaxed">
            Honest, detailed articles on plastic surgery procedures, recovery, and what patients need to know before making a decision.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="bg-warm-white py-16 px-4 md:px-8">
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <div key={post.slug} className="bg-white p-8 border border-deep-navy/10 flex flex-col">
                <p className="text-xs font-medium tracking-widest text-gold uppercase mb-4">
                  {post.category}
                </p>
                <h2 className="font-serif text-xl text-premium-purple mb-3 leading-snug">
                  {post.title}
                </h2>
                <p className="text-deep-navy/70 leading-relaxed mb-6 flex-1">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-sm text-deep-navy/40">
                    {post.date} &middot; {post.readTime}
                  </span>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="text-gold font-medium hover:text-deep-navy transition-colors text-sm"
                  >
                    Read Article →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-premium-purple py-16 px-4 md:px-8">
        <div className="container mx-auto max-w-7xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h2 className="font-serif text-3xl text-warm-white mb-3">
                Have a question? Let's talk.
              </h2>
              <p className="text-warm-white/70">
                Every treatment starts with a detailed, one-on-one consultation.
              </p>
            </div>
            <Button asChild className="btn-gold border-none rounded-none px-8 py-6 shrink-0">
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                Book Consultation
              </a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
